query Companies{
 companies{
  nodes{
    id
    __typename
    name
    _rowTimestamp
    _isUpdatable
    approvalPhaseTypeId
    homeCountryId
    currencyId
    timeZoneId
    distributionLayoutType
    corporationName
    corporateWorkgroupId
    companyAddressesByEntityId {
        nodes {
            id
            addressTypeId
            _rowTimestamp
            _isUpdatable
            addressLine1
            addressLine2
            cityName
            countryId
            stateRegionId
            postalCode
            telephoneNumber
            mobileNumber
            emailAddress
            mainContact
            isPrimaryAddress
            isDeliveryAddress
         }
      }
      companyValidCurrencies {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          currencyId
          companyExchangeRate
          companySpotRate
          _isHomeCurrency
          _isDeletable
        }
      }
    }
  }
}
